export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const ADULTS_COUNT_MIN = 1
export const ADULTS_COUNT_MAX = 30
export const CHILDREN_COUNT_MIN = 0
export const CHILDREN_COUNT_MAX = 30
export const MAX_TRAVELLERS_COUNT = 30
export const MAX_INSURANCE_OUTBOUND_AGE = 70
export const MAX_INSURANCE_INBOUND_AGE = 65
